module.exports = __webpack_public_path__ + "static/logo-9a3a70f664d4adac7808f7927850339e.png";